import { USER_QUERY_KEY } from "@frontend-shared/constants";
import type { IUserProfile } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { userApi } from "@/api/services";

export const useCompleteCaTour = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => userApi.completeCaTour(),
    onMutate: () => {
      queryClient.setQueryData<IUserProfile>([USER_QUERY_KEY], (old) => {
        if (!old) {
          return old;
        }

        return {
          ...old,
          isCaTourCompleted: true,
        };
      });
    },
    onError: (error) => {
      console.error("Failed to update CA tour completion status:", error);
    },
  });
};
